<template>
  <el-dialog :title="modalInfo.title" :visible.sync="modalInfo.isShow" v-if="modalInfo.isShow" width="30%">
    <el-form :model="modalInfo.form" :rules="rules" ref="ruleForm">
      <el-form-item label="角色名称" prop="roleName" :label-width="formLabelWidth" >
        <el-input v-model.trim="modalInfo.form.roleName"  size="small"></el-input>
      </el-form-item>
      <el-form-item label="排序" prop="sortNumber" :label-width="formLabelWidth">
        <el-input v-model.number="modalInfo.form.sortNumber" ></el-input>
      </el-form-item>
      <el-form-item label="备注说明" prop="roleDescription" :label-width="formLabelWidth">
        <el-input v-model.trim="modalInfo.form.roleDescription" size="small"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" class="confirm" @click="confirmClick()">确 定</el-button>
      <el-button size="small" class="cancel" @click="modalInfo.isShow = false">取 消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {fetchGet, fetchPost} from "@/libs/reqCommon";
export default {
    name:'newAddModel',
    props:{
      modalInfo:{
          type:Object,
          default:() =>{}
      }
    },
    data(){
      return {
          formLabelWidth:"120px",
          rules: {
            roleName: [
              { required: true, message: '角色名称不能为空', trigger: 'blur' }
            ],
            sortNumber: [
              { required: true, message: '排序不能为空' },
              { type: 'number', message: '排序必须为数字'}
            ]
          }
      }
    },
    methods:{
      confirmClick(){
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.reqNewAdd();
          } else {
            return false;
          }
        });
      },
      // 新增/编辑请求
      reqNewAdd(){
        let url = "/hcm/role/save";
        fetchPost(url,this.modalInfo.form).then(res =>{
          if(res.status == '10000'){
            this.$message({
              message: '操作成功！',
              type: res.message
            })
            this.modalInfo.isShow = false;
            this.$emit("reqTableData")
          }else{
            this.$message.error(res.message?res.message:'操作失败！');
          }     
        })
      }
    }
}
</script>
<style lang="scss">

</style>


